module.exports = "<div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input type=checkbox id=\"{%- value %}\" class=order-modal-checkbox value=\"{%- value %}\" name=\"{%- value %}\"/> <label for=\"{%- value %}\"></label> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/utilities/productsModalUtilities/html/modalCheckbox.html
// module id = 1454
// module chunks = 1